import { useQuery } from '@tanstack/react-query';
import type { MyTasksResponse } from '@task-tracker/shared';
import { apiClient } from '../lib/api-client';
import { CACHE_POLICY } from '../lib/cache-policy';

export const myTasksKeys = {
  list: () => ['my-tasks'] as const,
};

export function useMyTasks() {
  return useQuery({
    queryKey: myTasksKeys.list(),
    queryFn: () => apiClient<MyTasksResponse>('/api/v1/my-tasks'),
    ...CACHE_POLICY.operational,
  });
}
